import { createRouter, createWebHistory } from 'vue-router'
import Landing from '../views/Landing.vue'

// Existing Imports
import SignUp from '../views/SignUp.vue'
import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'
import WishboardCreate from '../views/WishboardCreate.vue'
import Wishboard from '../views/Wishboard.vue'
import WishboardList from '../views/WishboardList.vue'
import Payment from '../views/Payment.vue'
import Privacy from '../views/Privacy.vue'
import TermsOfService from '../views/TermsOfService.vue'
import Demo from '../views/Demo.vue'
import Celebration from '../views/Celebration.vue'
import Presentation from '../views/Presentation.vue'
import StudFinderSupport from '../views/StudFinderSupport.vue'
import StudFinderPrivacy from '../views/StudFinderPrivacy.vue'

// --- NEW RADIO APP IMPORTS ---
import MyGlobalRadioProSupport from '../views/MyGlobalRadioProSupport.vue'
import MyGlobalRadioProPrivacy from '../views/MyGlobalRadioProPrivacy.vue'


const routes = [
  {
    // Landing IS the home page. It is a superset of the old Home.vue — same three
    // steps, same feature set, plus a real occasion carousel — so the older page
    // was removed rather than kept at a second URL. `/landing` is kept as an alias
    // so existing links still resolve.
    path: '/',
    name: 'Home',
    component: Landing
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing,
  },
  // {
  //   path: '/Phrases',
  //   name: 'Phrases',
  //   component: Phrases
  // },

  {
    path: '/sign-up',
    name: 'SignUp',
    component: SignUp
  },
  {
    path: '/wishboardcreate',
    name: 'WishboardCreate',
    component: WishboardCreate
  },
  {
    path: '/wishboardlist',
    name: 'WishboardList',
    component: WishboardList
  },
  {
    path: '/wishboard/:wishboard_id?',
    name: 'Wishboard',
    component: Wishboard,
    // Compact: the nav collapses to the logo alone until hover, focus or tap, so a
    // shared board reads as a keepsake while every link stays one gesture away.
    meta: { chrome: 'compact' }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment
   },
   {
     path: '/privacy',
     name: '/Privacy',
     component: Privacy
   },
   {
     path: '/termsofservice',
     name: '/TermsOfService',
     component: TermsOfService
   },
   {
     path:'/demo',
     name:'/Demo',
     component: Demo     
   },
   {
     path:'/celebration',
     name:'/Celebration',
     component: Celebration
   },
   {
    path:'/presentation',
    name:'/Presentation',
    component: Presentation,
    // Brand only. Nobody needs "Create a Wishboard" or "Sign out" while watching
    // a board being presented, but a presented board should still show where it
    // came from and offer a way back -- this is a page people put on a TV.
    meta: { chrome: 'minimal' }
   },
   {
     path: '/icediscovery/studfinder/support',
     name: 'StudFinderSupport',
     component: StudFinderSupport
   },
   {
     path: '/icediscovery/studfinder/privacy',
     name: 'StudFinderPrivacy',
     component: StudFinderPrivacy
   },

   // --- NEW RADIO APP ROUTES ---
   {
     path: '/icediscovery/my-global-radio-pro/support',
     name: 'MyGlobalRadioProSupport',
     component: MyGlobalRadioProSupport
   },
   {
     path: '/icediscovery/my-global-radio-pro/privacy',
     name: 'MyGlobalRadioProPrivacy',
     component: MyGlobalRadioProPrivacy
   }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: '/',
  routes
})

export default router